/*
  TypeTopia — sign-in sheet (v1.4)

  v1.4 (2026-10-31, Ally of the homepage band's camera badge: "why camera icon has double outline"): opts.focusVisible:
  false hands the focus back as the sheet closes with focus({ focusVisible: false }), so the element it goes back to
  shows no focus ring for it (a browser that doesn't know the option focuses as before). Additive: without it, as before.

  v1.3 (2026-10-28, the homepage's "Who's it for?" band, sections/tt-home-who.liquid: Ally, "an account creation pop up
  on image upload so they can save for next time while also getting them their 10% off"): TTSignIn.open(opts) can give
  one opening its own words and parts. Additive only: open() / open({ from }) and mount() behave exactly as before.
    opts.copy      any of COPY's words for this opening (title, lead, small, doneTitle, doneLead, ...)
    opts.top       an element above the first step's title (their face)
    opts.done      an element at the end of the done step (the 10% code)
    opts.onEmail(address)   once a code has gone to that address (the newsletter sign-up beside it)
    opts.onDone()  signed in (their face saved); opts.stay: the sheet stays open on the done step
    opts.onClose() the sheet closed, however; opts.cls: a class on its card
    opts.start: 3  open on the done step; opts.force: open even when signed in (both: the 10% code after Shopify's check)
  The next plain open() is the plain sheet again.

  v1.2 (2026-10-08, Ally: "caps where they should be"): sentence-case labels.
  assets/tt-signin.js (+ assets/tt-signin.css), loaded by snippets/tt-signin.liquid

  v1.1 (2026-10-08, Ally: "I don't like the look of this"): the theme's look
  (see the CSS) and calmer: each step is a title, one line, the box (its
  label kept for screen readers, a placeholder in sight), one ink button and
  the quiet links. No new behaviour.

  v1 (2026-10-08, Ally: TypeTopia's own sign-in, no Shopify accounts): email,
  then the 6-digit code from TypeTopia's email, then you're in. Talks only to
  window.TTMyPersonalisation (assets/tt-my-personalisation.js), which talks to
  the worker and keeps the one sign-in token.

    · opens from anything with data-tt-signin while signed out (the header's
      "log in", the "create an account to save your faces" lines); signed in,
      those links go where they point (the my personalisation page);
    · TTSignIn.open({ from })   the sheet (a card near the top on phones, so
                                the keyboard never covers it; centred on
                                desktop). Escape, the x or a tap outside close it.
    · TTSignIn.mount(el, { onDone })   the same form inline (the my
                                personalisation page, signed out);
    · the code box is autocomplete="one-time-code" (iOS offers the code from
      Mail), numbers only, sends itself at 6 digits; "resend" after 30s;
      every failure says what to do next. Plain DOM, no <dialog>: it works in
      Instagram's in-app browser. Nothing moves the page or scrolls it.
*/
(function () {
  "use strict";
  if (window.TTSignIn) return;

  var COPY = {
    title: "Log in",
    lead: "Pop your email in and we’ll send you a 6-digit code. New here? That makes your account too.",
    emailLabel: "Your email",
    emailHint: "Your email",
    send: "Send my code",
    sending: "Sending…",
    small: "We only use your email to sign you in.",
    codeTitle: "Check your email",
    codeLead: "We’ve sent a code to ",
    codeLead2: ". It works for 10 minutes.",
    codeLabel: "6-digit code",
    check: "Log in",
    checking: "Checking…",
    resend: "Send a new code",
    resendIn: "New code in ",
    resent: "New code on its way.",
    change: "Use a different email",
    doneTitle: "You’re in",
    doneLead: "The faces you add now save to your account, ready for next time.",
    close: "Close",
    err: {
      email: "That email doesn’t look quite right. Have another look?",
      too_many: "That’s a lot of goes. Give it a few minutes, then try again.",
      send: "We couldn’t send the email just now. Give it another go?",
      network: "Couldn’t reach us just now. Check your signal and try again?",
      server: "Something went wrong our end. Give it another go?",
      code_short: "The code is 6 numbers: check the email we sent.",
      code_wrong: "That code’s not right. ",
      code_expired: "That code has run out. Tap “Send a new code” for a fresh one.",
      code_used_up: "Too many wrong goes on that code. Tap “Send a new code” for a fresh one."
    }
  };
  var RESEND_S = 30;
  var uid = 0;

  function M() { return window.TTMyPersonalisation || null; }
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function errText(r) {
    var code = (r && r.error) || "server";
    if (code === "code_wrong") {
      var n = r && r.triesLeft;
      return COPY.err.code_wrong + (n ? (n === 1 ? "1 go left." : n + " goes left.") : "Have another look?");
    }
    return COPY.err[code] || COPY.err.server;
  }

  /* one form: email → code → done. Used by the sheet and inline. */
  function makeForm(opts) {
    opts = opts || {};
    /* (v1.3) this form's words: COPY, with the opening's own over it */
    var T = COPY;
    if (opts.copy) { T = {}; for (var ck in COPY) T[ck] = COPY[ck]; for (ck in opts.copy) if (opts.copy[ck] != null) T[ck] = opts.copy[ck]; }
    var id = "tt-si-" + (++uid);
    var box = el("div", "tt-si__form");
    var address = "", timer = 0, left = 0, busy = false;

    // step 1: email
    var f1 = el("form", "tt-si__step", { novalidate: "" });
    var h1 = el("h2", "tt-si__h", { id: id + "-h" }); h1.textContent = T.title;
    var p1 = el("p", "tt-si__p"); p1.textContent = T.lead;
    var l1 = el("label", "tt-si__lbl tt-si__sr", { "for": id + "-email" }); l1.textContent = T.emailLabel;
    var inE = el("input", "tt-si__in", {
      id: id + "-email", type: "email", name: "email", autocomplete: "email", inputmode: "email", placeholder: T.emailHint,
      autocapitalize: "off", autocorrect: "off", spellcheck: "false", required: "", "aria-describedby": id + "-e1"
    });
    var e1 = el("p", "tt-si__err", { id: id + "-e1", "aria-live": "polite" });
    var b1 = el("button", "tt-si__btn", { type: "submit" }); b1.textContent = T.send;
    var s1 = el("p", "tt-si__small"); s1.textContent = T.small;
    [h1, p1, l1, inE, e1, b1, s1].forEach(function (n) { f1.appendChild(n); });
    if (opts.top) f1.insertBefore(opts.top, h1);                  /* (v1.3) */
    if (!T.small) s1.hidden = true;

    // step 2: code
    var f2 = el("form", "tt-si__step", { novalidate: "" }); f2.hidden = true;
    var h2 = el("h2", "tt-si__h", { id: id + "-h2", tabindex: "-1" }); h2.textContent = T.codeTitle;
    var p2 = el("p", "tt-si__p");
    var to = el("b", "tt-si__to");
    p2.appendChild(document.createTextNode(T.codeLead)); p2.appendChild(to); p2.appendChild(document.createTextNode(T.codeLead2));
    var l2 = el("label", "tt-si__lbl tt-si__sr", { "for": id + "-code" }); l2.textContent = T.codeLabel;
    var inC = el("input", "tt-si__in tt-si__in--code", {
      id: id + "-code", type: "text", name: "code", autocomplete: "one-time-code", inputmode: "numeric",
      pattern: "[0-9]*", maxlength: "6", required: "", "aria-describedby": id + "-e2"
    });
    var e2 = el("p", "tt-si__err", { id: id + "-e2", "aria-live": "polite" });
    var b2 = el("button", "tt-si__btn", { type: "submit" }); b2.textContent = T.check;
    var row = el("div", "tt-si__row");
    var bR = el("button", "tt-si__link", { type: "button" });
    var bC = el("button", "tt-si__link", { type: "button" }); bC.textContent = T.change;
    row.appendChild(bR); row.appendChild(bC);
    [h2, p2, l2, inC, e2, b2, row].forEach(function (n) { f2.appendChild(n); });

    // step 3: done
    var f3 = el("div", "tt-si__step tt-si__step--done"); f3.hidden = true;
    var h3 = el("h2", "tt-si__h", { tabindex: "-1" }); h3.textContent = T.doneTitle;
    var p3 = el("p", "tt-si__p"); p3.textContent = T.doneLead;
    f3.appendChild(el("span", "tt-si__tick", { "aria-hidden": "true" }));
    f3.appendChild(h3); f3.appendChild(p3);
    if (!T.doneLead) p3.hidden = true;
    if (opts.done) f3.appendChild(opts.done);                     /* (v1.3) */

    box.appendChild(f1); box.appendChild(f2); box.appendChild(f3);

    function say(where, t, good) { where.textContent = t || ""; where.classList.toggle("is-good", !!good); }
    function wait(btn, on, label) { busy = on; btn.disabled = on; btn.setAttribute("aria-busy", on ? "true" : "false"); btn.textContent = label; }
    function step(n) {
      f1.hidden = n !== 1; f2.hidden = n !== 2; f3.hidden = n !== 3;
      var focusEl = n === 1 ? inE : n === 2 ? inC : h3;
      try { focusEl.focus({ preventScroll: true }); } catch (e) {}
    }
    function tick() {
      clearInterval(timer);
      left = RESEND_S;
      var draw = function () {
        bR.disabled = left > 0;
        bR.textContent = left > 0 ? T.resendIn + left + "s" : T.resend;
      };
      draw();
      timer = setInterval(function () { left--; draw(); if (left <= 0) clearInterval(timer); }, 1000);
    }
    function send(again) {
      var m = M();
      if (!m || busy) return;
      if (!again) wait(b1, true, T.sending); else { busy = true; bR.disabled = true; }
      m.signIn(address).then(function (r) {
        if (!again) wait(b1, false, T.send); else busy = false;
        if (!r.ok) {
          if (again) { bR.disabled = false; bR.textContent = T.resend; say(e2, errText(r)); }
          else say(e1, errText(r));
          return;
        }
        to.textContent = address;
        inC.value = "";
        say(e2, again ? T.resent : "", again);
        tick();
        if (!again && opts.onEmail) try { opts.onEmail(address); } catch (x) {}     /* (v1.3) */
        if (!again) step(2);
        else try { inC.focus({ preventScroll: true }); } catch (e) {}
      });
    }

    f1.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = inE.value.trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(v)) { say(e1, T.err.email); try { inE.focus({ preventScroll: true }); } catch (x) {} return; }
      say(e1, "");
      address = v;
      send(false);
    });
    inE.addEventListener("input", function () { if (e1.textContent) say(e1, ""); });

    inC.addEventListener("input", function () {
      var d = inC.value.replace(/\D/g, "").slice(0, 6);
      if (inC.value !== d) inC.value = d;
      if (e2.textContent && !e2.classList.contains("is-good")) say(e2, "");
      if (d.length === 6) f2.requestSubmit ? f2.requestSubmit() : f2.dispatchEvent(new Event("submit", { cancelable: true }));
    });
    f2.addEventListener("submit", function (e) {
      e.preventDefault();
      var m = M();
      if (!m || busy) return;
      var c = inC.value.replace(/\D/g, "");
      if (c.length !== 6) { say(e2, T.err.code_short); return; }
      wait(b2, true, T.checking);
      m.verify(c, address).then(function (r) {
        wait(b2, false, T.check);
        if (!r.ok) {
          say(e2, errText(r));
          if (r.error === "code_wrong") { inC.select(); }
          return;
        }
        clearInterval(timer);
        step(3);
        if (opts && opts.onDone) opts.onDone();
      });
    });
    bR.addEventListener("click", function () { if (left <= 0) send(true); });
    bC.addEventListener("click", function () { clearInterval(timer); say(e2, ""); step(1); inE.select(); });

    return {
      el: box,
      labelId: id + "-h",
      reset: function () { clearInterval(timer); say(e1, ""); say(e2, ""); busy = false; b1.disabled = b2.disabled = false; b1.textContent = T.send; b2.textContent = T.check; f1.hidden = false; f2.hidden = true; f3.hidden = true; },
      focus: function () { step(f2.hidden ? 1 : 2); },
      toDone: function () { step(3); }                            /* (v1.3) */
    };
  }

  /* ── the sheet ── */
  var sheet = null, form = null, from = null, closeT = 0, card = null, own = null, quiet = false;
  /* (v1.3) the sheet's form: the plain one, or one opening's own (o: its opts) */
  function setForm(o) {
    var old = form;
    form = makeForm({
      copy: o && o.copy, top: o && o.top, done: o && o.done, onEmail: o && o.onEmail,
      onDone: function () {
        if (o && o.onDone) try { o.onDone(); } catch (e) {}
        if (!(o && o.stay)) closeT = setTimeout(close, 1100);
      }
    });
    own = o || null;
    sheet.setAttribute("aria-labelledby", form.labelId);
    if (old) card.replaceChild(form.el, old.el); else card.appendChild(form.el);
    card.className = "tt-si__card" + (o && o.cls ? " " + o.cls : "");
  }
  function build() {
    sheet = el("div", "tt-si", { role: "dialog", "aria-modal": "true" });
    sheet.hidden = true;
    var back = el("div", "tt-si__back");
    card = el("div", "tt-si__card");
    var x = el("button", "tt-si__x", { type: "button", "aria-label": COPY.close });
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    card.appendChild(x);
    setForm(null);
    sheet.appendChild(back); sheet.appendChild(card);
    back.addEventListener("click", close);
    x.addEventListener("click", close);
    sheet.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var f = [].slice.call(card.querySelectorAll("button, input, [tabindex='-1']")).filter(function (n) { return !n.disabled && n.offsetParent !== null && n.tabIndex >= 0; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus({ preventScroll: true }); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus({ preventScroll: true }); }
    });
    document.body.appendChild(sheet);
  }
  function open(opts) {
    var m = M();
    if (m && m.signedIn && !(opts && opts.force)) { location.href = m.accountUrl || "/pages/my-personalisation"; return; }
    if (!sheet) build();
    clearTimeout(closeT);
    /* (v1.3) an opening with its own words or parts gets its own form; the next plain one, the plain form again */
    var mine = !!(opts && (opts.copy || opts.top || opts.done || opts.onEmail || opts.onDone || opts.onClose || opts.stay || opts.cls || opts.start));
    if (mine || own) setForm(mine ? opts : null);
    from = (opts && opts.from) || document.activeElement;
    quiet = !!(opts && opts.focusVisible === false);
    form.reset();
    sheet.hidden = false;
    sheet.classList.remove("is-out");
    void sheet.offsetWidth;
    sheet.classList.add("is-on");
    if (opts && opts.start === 3) form.toDone(); else form.focus();
  }
  function close() {
    if (!sheet || sheet.hidden) return;
    if (own && own.onClose) try { own.onClose(); } catch (e) {}   /* (v1.3) */
    clearTimeout(closeT);
    sheet.classList.remove("is-on");
    sheet.classList.add("is-out");
    var done = function () { sheet.hidden = true; sheet.classList.remove("is-out"); };
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) done();
    else setTimeout(done, 200);
    /* (v1.4) an opening that asked for it hands the focus back without a focus ring (focusVisible: false) */
    if (from && from.focus && document.contains(from)) try { from.focus(quiet ? { preventScroll: true, focusVisible: false } : { preventScroll: true }); } catch (e) {}
    from = null;
  }

  function mount(host, opts) {
    var f = makeForm(opts || {});
    f.el.classList.add("tt-si__form--inline");
    host.appendChild(f.el);
    return f;
  }

  // "log in" and every "create an account" line: the sheet while signed out
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest && e.target.closest("[data-tt-signin]");
    if (!a) return;
    var m = M();
    if (m && m.signedIn) return;                         // signed in: the link goes where it points
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    open({ from: a });
  });

  window.TTSignIn = { open: open, close: close, mount: mount };
})();
